import React from 'react';
export function Card({title, action, hoverable, padding=20, children, style, ...rest}) {
  const [hover, setHover] = React.useState(false);
  return <div onMouseEnter={()=>setHover(true)} onMouseLeave={()=>setHover(false)}
    style={{background:'var(--surface)',border:'1px solid var(--border)',borderRadius:'var(--radius-lg)',
      boxShadow:hoverable&&hover?'var(--shadow-md)':'var(--shadow-sm)',transition:'box-shadow var(--dur-med) var(--ease-out)',
      fontFamily:'var(--font-sans)',...style}} {...rest}>
    {(title||action) && <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',padding:padding+'px '+padding+'px 0'}}>
      <span style={{fontWeight:600,fontSize:'var(--text-md)'}}>{title}</span>{action}
    </div>}
    <div style={{padding}}>{children}</div>
  </div>;
}
